<template lang="pug">
  div(class="vkb_nak" class="vkb_nak_vkb vkb_nak_riester_rente")
    div(ref="heading" class="large-12 columns")
      hr(class="topspace")

      div.row
        div.small-12.columns
          row-input(
            :title="'Meine persönliche Situation'"
            :label="'Familienstand*'"
            :validated="!$v.form.$invalid"
            :tooltip="tooltip.marital"
            :error="errorMessages.marital.valid"
            :invalid="checkValid && !$v.form.marital.valid"
          )
            div.select-wrapper(slot="input-control")
              select.dropdown(v-model="form.marital" @change="onSelectMarital")
                option(
                  v-for="option, index in optMarital"
                  :value="option.value"
                  :key="index"
                ) {{ option.label }}

          row-input(label="Geburtsjahr*" :tooltip="tooltip.birth_year")
            n-number(
              v-model="form.birth_year"
              slot="input-control"
              format="number"
              placeholder="z.B. 1975"
              :checkValid="checkValid"
              :valid="$v.form.birth_year.valid"
              :error="errorMessages.birth_year.valid"
              @input="onInputBirthYear"
            )

          row-input(
            :label="'Anzahl Kinder*'"
            :tooltip="tooltip.child_num"
            :error="errorMessages.child_num.valid"
            :invalid="checkValid && !$v.form.child_num.valid"
          )
            div.select-wrapper(slot="input-control")
              select.dropdown(v-model="form.child_num" @change="(e) => changeChildren()")
                option(
                  v-for="option, index in optChildren"
                  :value="option.value"
                  :key="index"
                ) {{ option.label }}

          div(v-if="form.child_num > 0")
            row-input(v-for="_, i in form.child_num" :key="i")
              n-number(
                v-model="form[`child_birth${ i + 1 }`]"
                slot="input-control"
                format="number"
                :label="`Geburtsjahr Kind ${ i + 1 }*`"
                :tooltip="!i ? tooltip.child_birth1 : ''"
                :placeholder="`${ minChildYear } oder jünger`"
                :checkValid="checkValid"
                :valid="$v.form[`child_birth${ i + 1 }`].valid"
                :error="errorMessages[`child_birth${ i + 1 }`].valid"
              )

          row-input(
            :label="'Bruttojahreseinkommen in €*'"
            :tooltip="tooltip.gross_salary"
            :error="getErrorMessage('gross_salary')"
            :invalid="checkValid && $v.form.gross_salary.$invalid"
          )
            n-number(v-model="form.gross_salary" slot="input-control" format="number")

          row-input(
            :label="'Geplanter Rentenbeginn*'"
            :tooltip="tooltip.retire_age"
            :error="errorMessages.retire_age.valid"
            :invalid="checkValid && !$v.form.retire_age.valid"
          )
            div.select-wrapper(slot="input-control")
              select.dropdown(v-model="form.retire_age")
                option(
                  v-for="option, index in optRetireAges"
                  :value="option.value"
                  :key="index"
                ) {{ option.label }}

          row-input
            label.ml-3(slot="input-label") * Pflichtangaben

          row-input(action-row)
            a(
              class="button call-to-action block"
              slot="input-button"
              href="#"
              @click="(e) => onBerechnenClick(e)"
            )
              span Ergebnis anzeigen
              i(class="fo fo-arrow-right")

      hr(ref="result" class="topspace")

      div.row(v-if="result")
        div.small-12.columns
          div(class="row form-spacing")
            div(class="large-5 medium-6 small-12 columns text-center")
              span(class="padding-top h2") Meine staatliche Förderung

          div(class="row form-spacing")
            div(class="large-4 medium-4 small-12 columns form-break-spacing")
              div(class="vkb-nak-chart")
                chart(:data="chartData" :height="324" v-if="chartData")

            div(class="large-8 medium-8 small-12 columns")
              div(class="row tk-vkb-producttable margin-top-table")
                table.comparisonchart
                  tbody
                    tr(v-for="item, index in resultData" :key="index")
                      td: label.pb-0
                        span(v-html="item.label")
                        i.fo.fo-exclamation.info-tooltip.ml-2.mb-0(v-if="!index")
                          span(class="hint" v-html="tooltip.eigenbeitrag")
                      td
                        b(v-if="index === 2" class="h3") {{ item.value }}
                        span(v-else) {{ item.value }}
                  tfoot
                    tr
                      td.presetting
                        span Meine gesamte <b>Förderquote</b> bis zum Rentenbeginn
                        span(class="presetting-bottom h3 h2-line-height")
                          | {{ formatPercent(result.funding_rate, 2) }} %
                      td(class="summary")
                        span Meine <b>Gesamtförderung</b> bis zum Rentenbeginn
                        span(class="summary-bottom h2")
                          | {{ formatMoney(result.total_funding, 2) }} &euro;

          div(class="hide-all show-large show-medium")
            div(class="row tk-vkb-producttable-action tk-vkb-fullsizebg2")
              div(class="row table-columns")
                div(class="small-12 medium-6 large-4 large-offset-4 columns")
                  a.ml-1(href="#" class="button button-link" @click="onGetPdfClick")
                    i(class="fo fo-download")
                    span Steuervorteil speichern
                    i(v-if="!!pdfJobId" class="fa fa-spinner fa-spin")

                div(class="small-12 medium-6 large-4 columns")
                  a(href="#" class="button call-to-action block" @click="onContactClick")
                    span Zur Beratung
                    i(class="fo fo-arrow-right")

          div(class="wrapper-spacing tk-vkb-notopspace hide-all show-small")
            div(class="row")
              div(class="small-12 columns topspace")
                a(href="#" class="button button-link block" @click="onGetPdfClick")
                  i(class="fo fo-download")
                  span Steuervorteil speichern
                  i(v-if="!!pdfJobId" class="fa fa-spinner fa-spin")

              div(class="small-12 columns topspace")
                a(href="#" class="button call-to-action block" @click="onContactClick")
                  span Zur beratung
                  i(class="fo fo-arrow-right")

</template>

<script>
import logic from './logic.js';
export default {
  name: 'riester_rente_vkb',

  mixins: [
    logic
  ]
};
</script>



// WEBPACK FOOTER //
// src/apps/riester_rente/vkb.vue